/**
 * Centralized API Client for Social & Discovery Features
 * Uses existing authentication infrastructure
 */
import axios from 'axios';
import config from '../../config';

const API_BASE_URL =
  config.TRAVELHEARTS_API_URL || 'http://localhost:3000/api/v1';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor - add auth token from existing storage
apiClient.interceptors.request.use(
  (axiosConfig) => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const userData = JSON.parse(userStr);
        const token = userData.token;
        if (token) {
          axiosConfig.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Failed to parse user data:', error);
      }
    }
    return axiosConfig;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // User is unauthorized - clear local storage and redirect
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
